<template lang="pug">
  .table__body.msg-header__body
      .table__body-content
          ul.table__nav-list.msg-table
            li.table__col
              p.table__col-title.msg-text
                | Канал {{currentMonth}}
            li.table__col(v-for="(item, key) in getMonth" :key="key")
              .msg-table-info
                p.table__col-title.msg-text
                  | {{item.title}}
              .msg-table-types
                .msg-date(
                  :class="(typeof currentMonthAndType === 'boolean' && !currentMonthAndType && currentMonth == item.id ) && 'msg-date__current'"
                )
                  p.table__col-title.msg-text
                    | Промеж.
                .msg-date(
                  :class="(typeof currentMonthAndType === 'boolean' && currentMonthAndType && currentMonth == item.id) && 'msg-date__current'"
                )
                  p.table__col-title.msg-text
                    | Итог
            li.table__col
              p.table__col-title.msg-text
                | Всего
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {
      month: [
        {
          id: 8,
          title: 'Сентябрь'
        },
        {
          id: 9,
          title: 'Октябрь'
        },
        {
          id: 10,
          title: 'Ноябрь'
        },
        {
          id: 11,
          title: 'Декабрь'
        },
        {
          id: 0,
          title: 'Январь'
        },
        {
          id: 1,
          title: 'Февраль'
        },
        {
          id: 2,
          title: 'Март'
        },
        {
          id: 3,
          title: 'Апрель'
        },
        {
          id: 4,
          title: 'Май'
        },
        {
          id: 5,
          title: 'Июнь'
        },
        {
          id: 6,
          title: 'Июль'
        },
        {
          id: 7,
          title: 'Август'
        }
      ]
    };
  },
  computed: {
    currentMonthAndType() {
      // let prefixes = [1,2,3,4,5];
      // let lastWeeks = 3;
      // if( this.isCurrentYear == 'current')
      //   return prefixes[0 | moment().date() / 7] >= lastWeeks

      // return ''
      return moment().date() >= 15;
    },
    currentMonth() {
      return moment().month();
    },
    isCurrentYear() {
      let year = moment().year();

      if (this.$route.query.year) {
        year = this.$route.query.year;
      }

      if (moment().year() == year) {
        return 'current';
      }

      return moment().year() > year;
    },
    getMonth() {
      const month = [...this.month];

      if (this.period == 1) {
        return month.splice(0, 6);
      } else {
        return month.splice(6, 11);
      }
    },
    period() {
      if (this.$route.query.period) {
        return this.$route.query.period;
      }

      return 1;
    }
  }
};
</script>
